import dayjs from "dayjs";

import { Invoice } from "../bitmaker/schemas/Billing/Invoice";
import { Client } from "../bitmaker/schemas/Billing/Client";

export type DisplayStatus =
  | "Draft"
  | "Sent"
  | "Viewed"
  | "Partially Paid"
  | "Paid"
  | "Overdue";

export const getDaysDue = (dueDate: string): string => {
  const diff = dayjs(dueDate).diff(dayjs(), "days");

  if (diff < 0) return `Overdue by ${Math.abs(diff)} days`;
  if (diff === 0) return "Due today";
  return `Due in ${diff} days`;
};

export const getDisplayStatus = (invoice: Invoice): DisplayStatus => {
  const status = invoice.status;

  if (status === "paid") return "Paid";

  const isOverdue =
    ["sent", "viewed", "partially_paid"].includes(status) &&
    dayjs(invoice.dueDate).isBefore(dayjs(), "day");

  if (isOverdue) return "Overdue";

  switch (status) {
    case "draft":
      return "Draft";
    case "sent":
      return "Sent";
    case "viewed":
      return "Viewed";
    case "partially_paid":
      return "Partially Paid";
    default:
      return "Draft";
  }
};

export const getStatusColor = (status: DisplayStatus): string => {
  switch (status) {
    case "Paid":
      return "green";
    case "Overdue":
      return "volcano";
    case "Partially Paid":
      return "orange";
    case "Viewed":
      return "geekblue";
    case "Sent":
      return "blue";
    default:
      return "default";
  }
};

export const getClientDisplayTitle = (
  client: Client,
): {
  primary: string;
  secondary: string | null;
} => {
  const personalName = `${client.firstName || ""} ${client.lastName || ""
    }`.trim();

  if (client.corporateName) {
    return {
      primary: client.corporateName,
      secondary: personalName || null,
    };
  }

  if (client.companyName) {
    return {
      primary: client.companyName,
      secondary: personalName || null,
    };
  }

  return {
    primary: personalName || "Client",
    secondary: null,
  };
};

export const getInvoiceClientDisplayName = (invoice: Invoice): string => {
  const personalName = `${invoice.clientFirstName || ""} ${invoice.clientLastName || ""
    }`.trim();

  if (invoice.clientCorporateName) return invoice.clientCorporateName;
  if (invoice.clientCompanyName) return invoice.clientCompanyName;

  return personalName || "Client";
};
